import { apiDelete, apiGet, apiPatch, apiPost } from "../../../utils";

export const getElectricLaytimeAPI = (query) => {
    let url = `/api/operation/get-electric-laytime?offset=${query.offset}&limit=${query.limit}`;
    if (query.sortBy) url += `&sortBy=${query.sortBy}`;
    if (query.sortDirection) url += `&sortDirection=${query.sortDirection}`;
    return apiGet(url);
};

export const getElectricSofAPI = (query) => {
    let url = `/api/operation/get-electric-sof?offset=${query.offset}&limit=${query.limit}`;
    if (query.sortBy) url += `&sortBy=${query.sortBy}`;
    if (query.sortDirection) url += `&sortDirection=${query.sortDirection}`;
    return apiGet(url);
};


export const createElectricLaytimeAPI = (payload) => {
    return apiPost('/api/operation/create-electric-laytime', payload);
};

export const createElectricLaytimePdfAPI = (payload) => {
    return apiPost('/api/operation/create-electric-laytime-pdf', payload);
};

export const createElectricSofAPI = (payload) => {
    return apiPost('/api/operation/create-electric-sof', payload);
};

export const createElectricSofPdfAPI = (payload) => {
    return apiPost('/api/operation/create-electric-sof-pdf', payload);
};

export const updateElectricLaytimeAPI = (params, payload) => {
    const { _id = '' } = params || {};
    return apiPatch(`/api/operation/update-electric-laytime/${_id}`, payload);
};

export const updateElectricSofAPI = (params, payload) => {
    const { _id = '' } = params || {};
    return apiPatch(`/api/operation/update-electric-sof/${_id}`, payload);
};

export const deleteElectricLaytimeAPI = (params) => {
    const { _id = '' } = params || {};
    return apiDelete(`/api/operation/delete-electric-laytime/${_id}`);
};

export const deleteElectricSofAPI = (params) => {
    const { _id = '' } = params || {};
    return apiDelete(`/api/operation/delete-electric-sof/${_id}`);
};

